import { AutomationValue } from './ast/AutomationValue.js'
import { getServiceDataSuggestions } from '../utils/hassServiceData.js'

export function getActionDataSuggestions(action, object, eventName = '') {
    if (!action?.service) return []
    const identifier = String(action.service)
    const dot = identifier.indexOf('.')
    const provider = action.provider || (dot > 0 ? identifier.slice(0, dot) : '')
    const service = dot > 0 ? identifier.slice(dot + 1) : identifier
    if (!provider || !service) return []
    return getServiceDataSuggestions(
        provider,
        service,
        object?.schemaV2 ?? object?.obj ?? null,
        object,
        eventName,
    )
}

/**
 * Combine schema-v2 suggestions with the selected service's metadata fields.
 * Metadata fields deliberately have an empty value: selecting one adds the
 * parameter, after which the typed service-field editor supplies its value.
 */
export function getAvailableActionDataSuggestions(action, serviceOption, object, eventName = '') {
    const authored = getActionDataSuggestions(action, object, eventName)
    const metadata = Object.entries(serviceOption?.fields ?? {})
        .filter(([parameter]) => parameter !== 'entity_id')
        .map(([parameter, definition]) => ({
            parameter,
            value: '',
            label: definition?.name || parameter,
        }))
    const seen = new Set()
    return [...authored, ...metadata].filter(suggestion => {
        const id = suggestionId(suggestion)
        if (seen.has(id)) return false
        seen.add(id)
        return true
    })
}

export function suggestionId(suggestion) {
    return `${suggestion.parameter}:${suggestion.value}`
}

/** Apply one schema suggestion to every repeated action in the rule. */
export function applyActionDataSuggestion(actions, suggestion) {
    if (!suggestion) return
    const value = String(suggestion.value ?? '')
    const source = value.startsWith('object.')
        ? 'object'
        : /{{[\s\S]*}}/.test(value) ? 'event' : 'literal'
    const storedValue = source === 'event'
        ? AutomationValue.template(value)
        : AutomationValue.literal(value)
    for (const action of actions) {
        action.parameters ??= []
        const existing = action.parameters.find(parameter => parameter.key === suggestion.parameter)
        if (existing) {
            existing.source = source
            existing.value = storedValue
        } else {
            action.parameters.push({
                key: suggestion.parameter,
                source,
                value: storedValue,
            })
        }
    }
}
